module.exports = __webpack_public_path__ + "assets/36602fcfac2a0b2d1aea949c806abd0f.png";